export const tr = {
    add: 'Ekle'
};
